export default __webpack_public_path__ + "static/fortnite-screen-ae949de044ab609a2695c0abdaf4a7af.png";